const initState = {
  createPassword: {
    success: null,
    error: null,
    code: null,
    message: null,
  },
};

export default initState;
